import { expVal } from '@atlassian/jira-feature-experiments';

const JivColouredDueDateUiChangesRelayprovider = {
	get(): boolean {
		return expVal('exp-jiv-coloured-due-date-ui-changes', 'isEnabled', false);
	},
};

export default JivColouredDueDateUiChangesRelayprovider;
